import React from "react";
import {
  MdHome,
  MdPerson,
  MdLock,
  MdPeople,
  MdAccessTime,
  MdLocationOn,
  MdEventAvailable,
  MdBeachAccess,
  MdBusiness,
    MdAssignmentTurnedIn,
  MdCalendarViewWeek,
} from "react-icons/md";

// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import LeaveList from "views/hrms/leaves/LeaveList";
import HolidayList from "views/hrms/holidays/HolidayList";
import OfficeList from "views/hrms/offices/OfficeList";
import AddOffice from "views/hrms/offices/AddOffice";
import EditEmployee from "views/hrms/employees/EditEmployee";
// Auth Imports
import SignIn from "views/auth/SignIn";

// HRMS Pages
import EmployeeList from "views/hrms/employees/EmployeeList";
import EmployeeForm from "views/hrms/employees/EmployeeForm";
import EmployeeDetail from "views/hrms/employees/EmployeeDetails";
import AttendancePage from "views/hrms/attendence/AttendancePage";
import GpsTrackingPage from "views/hrms/gps/GpsTrackingPage";
import NewLeavePage from "views/hrms/leaves/LeaveNew";
import HolidayCreatePage from "views/hrms/holidays/HolidayCreatePage";
import HolidayEditPage from "views/hrms/holidays/HolidayEditPage";
import OfficeViewPage from "views/hrms/offices/OfficeViewPage";
import OfficeEditPage from "views/hrms/offices/OfficeEditPage";
import EmployeeSalary from "views/hrms/employees/EmployeeSalary";
import EmployeeWeeklyOffPicker from "views/hrms/holidays/EmployeeWeeklyOffPicker";
import RegularizationList from "views/hrms/attendence/RegularizationList";

// import GpsWebTracker from "views/hrms/gps/GpsWebTracker";

const routes = [
  /* ─── Dashboard ─────────────────────────────────────────── */
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },

  /* ─── Employees ──────────────────────────────────────────── */
  {
    name: "Employees",
    layout: "/admin",
    path: "hrms/employees",
    icon: <MdPeople className="h-6 w-6" />,
    component: <EmployeeList />,
  },
  {
    name: "Add Employee",
    layout: "/admin",
    path: "hrms/employees/new",
    icon: <MdPeople className="h-6 w-6" />,
    component: <EmployeeForm />,
    hidden: true, // keep hidden from sidebar if you wish
  },
  {
    name: "Employee Detail",
    layout: "/admin",
    path: "hrms/employees/:id",
    icon: <MdPeople className="h-6 w-6" />,
    component: <EmployeeDetail />,
    hidden: true,
  },
  {
    name: "Employee Edit",
    layout: "/admin",
    path: "hrms/employees/:id/edit",
    icon: <MdPeople className="h-6 w-6" />,
    component: <EditEmployee />,
    hidden: true,
  },
  {
    name: "Employee Salary",
    layout: "/admin",
    path: "hrms/employees/:id/salary",
    icon: <MdLocationOn className="h-6 w-6" />,
    component: <EmployeeSalary />,
    hidden: true,
  },
  /* ─── Attendance ─────────────────────────────────────────── */
  {
    name: "Attendance",
    layout: "/admin",
    path: "hrms/attendances",
    icon: <MdAccessTime className="h-6 w-6" />,
    component: <AttendancePage />,
  },
  {
    name: "Attendance",
    layout: "/admin",
    path: "hrms/attendances/:id",
    icon: <MdAccessTime className="h-6 w-6" />,
    component: <AttendancePage />,
    hidden: true,
  },
    {
    name: "Regularization",
    layout: "/admin",
    path: "hrms/regularizations",
    icon: <MdAssignmentTurnedIn className="h-6 w-6" />,
    component: <RegularizationList />,
  },
  /* ─── Leaves ─────────────────────────────────────────────── */
  {
    name: "Leaves",
    layout: "/admin",
    path: "hrms/leaves",
    icon: <MdEventAvailable className="h-6 w-6" />,
    component: <LeaveList />,
  },
  {
    name: "New Leave",
    layout: "/admin",
    path: "hrms/leaves/new",
    icon: null,
    component: <NewLeavePage />, // <-- component from step 3
    hidden: true, // keep it out of the sidebar
  },
  /* ─── Holidays ───────────────────────────────────────────── */
  {
    name: "Holidays",
    layout: "/admin",
    path: "hrms/holidays",
    icon: <MdBeachAccess className="h-6 w-6" />,
    component: <HolidayList />,
  },
  {
    name: "New Holidays",
    layout: "/admin",
    path: "hrms/holidays/new",
    icon: <MdBeachAccess className="h-6 w-6" />,
    component: <HolidayCreatePage />,
    hidden: true,
  },
  {
    name: "Edit Holidays",
    layout: "/admin",
    path: "hrms/holidays/:id/edit",
    icon: <MdBeachAccess className="h-6 w-6" />,
    component: <HolidayEditPage />,
    hidden: true,
  },
  {
    name: "Employee Weekly Off",
    layout: "/admin",
    path: "hrms/holidays/employee-weekly-offs",
    icon: <MdCalendarViewWeek className="h-6 w-6" />,
    component: <EmployeeWeeklyOffPicker />,
    hidden: true,
  },
  /* ─── Offices ────────────────────────────────────────────── */
  {
    name: "Offices",
    layout: "/admin",
    path: "hrms/offices",
    icon: <MdBusiness className="h-6 w-6" />,
    component: <OfficeList />,
  },
  {
    name: "Add Office",
    layout: "/admin",
    path: "hrms/offices/new",
    icon: <MdPeople className="h-6 w-6" />,
    component: <AddOffice />,
    hidden: true,
  },
  {
    name: "Views Office",
    layout: "/admin",
    path: "hrms/offices/:id",
    icon: <MdPeople className="h-6 w-6" />,
    component: <OfficeViewPage />,
    hidden: true,
  },
  {
    name: "Edit Office",
    layout: "/admin",
    path: "hrms/offices/:id/edit",
    icon: <MdPeople className="h-6 w-6" />,
    component: <OfficeEditPage />,
    hidden: true,
  },

  /* ─── GPS ────────────────────────────────────────────────── */
  {
    name: "GPS Tracking",
    layout: "/admin",
    path: "hrms/gps",
    icon: <MdLocationOn className="h-6 w-6" />,
    component: <GpsTrackingPage />,
  },
  /* ─── Profile / Auth ─────────────────────────────────────── */
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },

  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];

export default routes;
